import { updateEmployeeStatus } from "../../../../../actions/Utilities/EmployeeStatus";
import { useMutation, useQueryClient } from "react-query";
import { toast } from "../../../../../components/toastNotification";

const useUpdateEmployeeStatus = () => {
  const queryClient = useQueryClient();

  const { mutate } = useMutation(
    (employeeStatusNewData) => updateEmployeeStatus(employeeStatusNewData),
    {
      onSuccess: (res) => {
        if (res == "Duplicate") {
          toast.fire(
            "Saving Failed",
            "Employee Status already exists!",
            "error"
          );
        } else {
          queryClient.invalidateQueries(["GetEmployeeStatus"]);
          toast.fire(
            "Success",
            "Employee Status Updated Successfully",
            "success"
          );
        }
      },
      onError: () => {
        toast.fire("Failed", "Failed to Update Employee Status", "error");
      },
    }
  );
  return mutate;
};
export default useUpdateEmployeeStatus;
